import { marketingConversationHydratedSchema } from "@redotech/redo-model/marketing/marketing-conversation/marketing-conversation-definition";
import { marketingMessageSchema } from "@redotech/redo-model/marketing/marketing-message/marketing-message-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getQueueConversations = {
  name: "getQueueConversations" as const,
  input: z.object({
    teamId: zExt.objectId().optional(),
    limit: z.number(),
    offset: z.number(),
  }),
  output: z.object({
    conversations: z.array(marketingConversationHydratedSchema),
    messagesMap: z.record(z.string(), z.array(marketingMessageSchema)),
    total: z.number(),
  }),
};
